import { Select } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { GET_TASK_TEMPLATES } from 'src/graphql/taskTemplates.graphql'

import { inlineSelectProps } from './inlineSelectStyles'

const TaskTemplateOptions = ({
  selectedTaskTemplate,
  setSelectedTaskTemplate,
}) => {
  const { data: taskTemplatesList } = useQuery(GET_TASK_TEMPLATES, {
    variables: {
      pageInfo: {
        limit: 100,
        offset: 0,
      },
      orderBy: {
        field: 'title',
        direction: 'asc',
      },
    },
  })

  const taskTemplates = taskTemplatesList?.taskTemplates?.items ?? []

  return (
    <div className="flex flex-col gap-3 text-xs">      {taskTemplates.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No task templates found.
        </div>
      ) : (
        <Select
          {...inlineSelectProps}
          value={selectedTaskTemplate?.taskTemplateId}
          onChange={(value) =>
            setSelectedTaskTemplate({ taskTemplateId: value })
          }
          data={taskTemplates.map((t) => ({
            value: t.taskTemplateId,
            label: t.title,
          }))}
          className="max-w-sm"
          searchable
        />
      )}
    </div>
  )
}

export default TaskTemplateOptions
